import { device } from 'constants/media-query'
import styled from 'styled-components'

export const StyledFamilyAndFriendsCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 4px 16px 0 rgba(39, 39, 39, 0.1);
`

export const StyledUserName = styled.h3`
  display: flex;
  height: 33px;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  margin: 0;
  @media ${device.desktop} {
    text-align: center;
  }
`
